import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How *do* you standout as a developer?",
  "description": "Course creators are always telling you to learn this or that but how does any of it help *your* goals? That's the missing piece 🤔",
  "published": "2020-11-26T00:00:00.000Z",
  "hero": "./img/screenshot-1606409074013.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Course creators are always telling you to learn this or that but how does any of it help `}<em parentName="p">{`your`}</em>{` goals? That's the missing piece 🤔`}</p>
    <p>{`Courses come out of 2 places: passion and opportunity.`}</p>
    <p>{`Person stumbles into a technology, gets excited by the possibilities, tells everyone. `}<em parentName="p">{`"Wow this thing is amazing look what I can do!"`}</em></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "840px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/c18359cb5761fc7bbc227e479c57daf5/1e088/The-super-power-is-the-goal70f3ci.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "52.017937219730946%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'208\\'%20viewBox=\\'0%200%20400%20208\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M288%2033l-2%202c-2%200-2%201-2%204s0%204-2%204-2%201-2%204%200%204%202%204l2%202c0%202%201%202%204%202s4%200%204%202c0%201%200%202-2%201l-2%202-2%202c-2%201-2%202-2%204%200%203%200%204-2%204s-2%201-2%206c0%206%200%206%203%206%202%200%202%200%202-3s0-4%202-4c2-1%202-2%202-6%200-5%200-6%202-6l1%207c0%207%200%208%202%208s2%201%202%204c0%204%200%204%202%204s3%201%203%202c0%202%201%202%204%202s4%200%204%202%201%202%207%202c5%200%206%200%206-2s1-2%208-2h8V75h-4c-3%200-4%200-5-2%200-2-1-2-4-2s-4%200-3%202l-4%201-5-1%202-2%202-2c0-2-1-3-2-3l-2-2%202-2%202-2c0-2%201-2%206-2l6-1c0-1%201-2%203-2s2%200%202-4c0-3%200-4%202-4%203-1%203-8%200-8-2%200-3-1-3-2%200-2-1-2-4-2s-4%200-4-2-1-2-18-2c-18%200-19%200-19%202m73%202l-2%202c-2%200-2%201-2%204s0%204-2%204-2%201-2%204%200%204%202%204l2%202-2%201c-1%200-2%201-2%203l2%202%202-2%202-2%202-2-2-2c-4-1-2-4%202-4s4%200%204%204c0%202%200%203%202%204l2%202c1%203%2013%203%2013%200l2-2c2%200%202-1%202-8s0-8-2-8l-2-2-2-2-2-2c0-2-1-2-8-2-8%200-9%200-9%202M37%2068l-2%202c-2%200-2%201-2%204s0%204-2%204-3%201-3%206v6h4c4%200%205%200%205%202l-2%202-2%202-3%202-2%202c0%201%200%202-2%202s-2%201-2%203l1%208c0%204%200%204%204%204%204%201%206%204%202%204l-2%202-2%202c-2%200-3%201-3%202%200%202%201%202%208%202h9v-3c0-3%200-4%202-4l2-2c0-2%201-2%204-2s4%200%204%202l2%202c2%200%202%201%202%204v3h9c7%200%208%200%208-2l-2-2-2-2-2-2c-4-1-2-4%202-4%203%200%203%200%203-4l1-8c0-3%200-3-2-3l-2-2c0-2-1-2-6-2-6%200-7%200-6-3l4-1c2%200%203%200%203-2%200-1%201-2%203-2l2-2%202-2%201-2c0-1%200-2-2-1l-2-2c0-1-1-2-4-2-5-1-5-4%200-4%204%200%205-1%205-2%200-2-1-3-6-3s-6-1-6-2-2-2-11-2-10%200-10%202m113%209c0%202-1%202-4%202-4%200-4%200-4%204%200%203%200%203%204%203%203%200%204%200%204%202s1%202%2017%202c15%200%2016%200%2016-2s1-2%204-2c4%200%204%200%204-3%200-4%200-4-4-4s-4-1-4-2c0-2-1-2-16-2-16%200-17%200-17%202m-49%209l-1%205v4h-4c-6%200-6%202-1%202l5%201v4c0%207%203%207%203%201v-5h5c6-1%207-3%200-3h-5v-5c0-5-1-6-2-4m220%2013l-2%202-2%202c0%202-1%202-4%202s-4%200-4%202l-2%202c-1%200-2%201-2%203l2%202%202-2c0-2%201-2%204-2%204%200%204-1%204-2%200-2%201-2%202-2%202%200%203-1%203-2l2-2c2%200%202-1%202-2-1-3-4-4-5-1m-159%2011c0%2011%200%2012-2%2012s-2-1-2-4%200-4-2-4l-2-2-2-2-2-2-2-2-2-2c0-2-1-2-6-2l-6%201c-1%202%200%203%202%203s2%201%202%204%200%204%202%204%202%201%202%204%200%204%202%204l2%202c0%202%201%202%206%202s6%200%206%202l9%201%208-1c-1-2%200-2%205-2s6%200%207-2l2-2c2-1%202-2%202-4%200-3%200-4%202-4s2-1%202-4%200-4%202-4l2-2c0-2-1-2-6-2s-6%200-6%202l-2%202-2%202-2%202-2%202-3%202c-2%200-2%200-2%204%200%203%200%204-2%204-1%200-2-1-2-12V98h-8v12m111-8l-1%2014c0%2012%200%2013%202%2013l2-2%202-2%202-2c1-2%202-2%205-2h4v-19l-8-1-8%201m36%2021v6h13c11%200%2012%200%2012-2s-1-2-4-2h-4v-8h-17v6M3%20202l2%202a18130%2018130%200%2000-1-2H3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c18359cb5761fc7bbc227e479c57daf5/ca0a1/The-super-power-is-the-goal70f3ci.webp 223w", "/static/c18359cb5761fc7bbc227e479c57daf5/75680/The-super-power-is-the-goal70f3ci.webp 445w", "/static/c18359cb5761fc7bbc227e479c57daf5/ed60d/The-super-power-is-the-goal70f3ci.webp 840w"],
                "sizes": "(max-width: 840px) 100vw, 840px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c18359cb5761fc7bbc227e479c57daf5/e92b6/The-super-power-is-the-goal70f3ci.png 223w", "/static/c18359cb5761fc7bbc227e479c57daf5/e66bf/The-super-power-is-the-goal70f3ci.png 445w", "/static/c18359cb5761fc7bbc227e479c57daf5/1e088/The-super-power-is-the-goal70f3ci.png 840w"],
                "sizes": "(max-width: 840px) 100vw, 840px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c18359cb5761fc7bbc227e479c57daf5/1e088/The-super-power-is-the-goal70f3ci.png",
                "alt": "The super power is the goal",
                "title": "The super power is the goal",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`The super power is the goal`}</figcaption>{`
  `}</figure></p>
    <p>{`They found a flower and it gave them superpowers. But the flower was hard to eat.`}</p>
    <p>{`You need to cook it right. Cut off the stem, avoid the poisonous seed, boil the leaves, and flambé the petals. Then you gotta freeze for 2 hours before warming up in the microwave.`}</p>
    <p>{`That's opportunity. Help folks avoid the poisonous seed and the months of research.`}</p>
    <p>{`A new course is born. 👼`}</p>
    <h2 {...{
      "id": "when-to-buy-a-course"
    }}>{`When to buy a course`}</h2>
    <p>{`You buy the course when you want the super power.`}</p>
    <p>{`Lots of engineers cherish the discovery process. Pick a technology and `}<em parentName="p">{`figure it out`}</em>{`. It's fun and rewarding. Bang your head against the wall until it breaks.`}</p>
    <p>{`You end up with lots of knowledge.`}</p>
    <p>{`Little details you've figured out, patterns you've uncovered, and massive gaping holes you don't even know you're missing. The typical self-taught challenge.`}</p>
    <p>{`We see this a lot at my dayjob when interviewing experienced engineers.`}</p>
    <p><em parentName="p">{`"You know SQL right, use it all the time?"`}</em></p>
    <p><em parentName="p">{`"Oh yeah lots, our entire database is SQL and I fetch data like at least once a week"`}</em></p>
    <p><em parentName="p">{`"Okay how would you design a schema for a user table?"`}</em></p>
    <p><img parentName="p" {...{
        "src": "/9435eb7b6ad66fa28ea7ccce771ed5f9/giphygifidc66f.gif",
        "alt": null
      }}></img></p>
    <p>{`Oops, candidate "knows SQL" in that they know where to find mystic incantations in their codebase and cobble them together into something new.`}</p>
    <p>{`Knowledge, no understanding.`}</p>
    <h2 {...{
      "id": "how-to-leverage-a-course"
    }}>{`How to leverage a course`}</h2>
    <p>{`A good course helps you in 3 ways:`}</p>
    <ol>
      <li parentName="ol">{`Skip the long research process`}</li>
      <li parentName="ol">{`A guide through unknown terrain`}</li>
      <li parentName="ol">{`Understand, don't just know`}</li>
    </ol>
    <p>{`You get the super power faster `}<em parentName="p">{`and`}</em>{` you avoid the bad parts. When you're done, you understand the material.`}</p>
    <p>{`Understanding compounds over time, knowledge doesn't.`}</p>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/why-understanding-beats-knowledge"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "55.15695067264574%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'221\\'%20viewBox=\\'0%200%20400%20221\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M44%2039l-1%2019-4%2063c0%202-1%204-3%204l-3%202h3c4-1%204-3%200%2024l-2%2021h-6c-8%200-8%202%200%202h5l-1%204c-1%206-1%206-6%206-5-1-14%200-14%201h19v3c-2%208-2%2012-1%2012l1-8%202-6%205-1%2028-1c39-3%2054-3%20110-2a522%20522%200%200196%203%201786%201786%200%2000-235-1h-4v-5l1-5%2029-3a350%20350%200%2000-23%201h-5v-4a2300%202300%200%20006-42l31-9a1524%201524%200%2001193-43h4l-3%202-2%204%204-3c2-4%203-4%2023-8a485%20485%200%2001-4-1c-15%203-14%203-13%201l-2%201c-1%202-6%203-33%208-88%2017-96%2019-152%2034-46%2012-46%2012-46%2010a6068%206068%200%20013-83m200%2095c-3%205-2%206%207%206l7-1-2-2c-1-1-1-1%201-2%203-1%204-1%204%201v2l1-2%202-2%201-1c0-2-6-1-10%201-4%201-4%202-1%204%202%201%202%201%200%201l-5-1c-2%200-2%200-1-1%202-1%203-4%200-4-2-1-3-1-4%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f8defaecd9535175e9c643ccfe6335f6/ca0a1/Understanding-beats-knowledge9ea0gg.webp 223w", "/static/f8defaecd9535175e9c643ccfe6335f6/75680/Understanding-beats-knowledge9ea0gg.webp 445w", "/static/f8defaecd9535175e9c643ccfe6335f6/8d1ba/Understanding-beats-knowledge9ea0gg.webp 890w", "/static/f8defaecd9535175e9c643ccfe6335f6/a9a89/Understanding-beats-knowledge9ea0gg.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f8defaecd9535175e9c643ccfe6335f6/e92b6/Understanding-beats-knowledge9ea0gg.png 223w", "/static/f8defaecd9535175e9c643ccfe6335f6/e66bf/Understanding-beats-knowledge9ea0gg.png 445w", "/static/f8defaecd9535175e9c643ccfe6335f6/4ef49/Understanding-beats-knowledge9ea0gg.png 890w", "/static/f8defaecd9535175e9c643ccfe6335f6/2bef9/Understanding-beats-knowledge9ea0gg.png 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f8defaecd9535175e9c643ccfe6335f6/4ef49/Understanding-beats-knowledge9ea0gg.png",
                "alt": "Understanding beats knowledge",
                "title": "Understanding beats knowledge",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Understanding beats knowledge`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Once you understand cooking, you can look in the fridge and whip up a meal. Bit of this, bit of that, everyone's happy.`}</p>
    <p>{`Or you can follow recipes and get stuck when there's a bug or your ingredients don't match ...`}</p>
    <p>{`Same with code: When you understand the rules, you can use the recipe as a guideline. No need to memorize. But if there's a bug, something doesn't quite fit, you got dis. 💪`}</p>
    <h2 {...{
      "id": "can-courses-make-you-money-and-supercharge-your-career"
    }}>{`Can courses make you money and supercharge your career?`}</h2>
    <p>{`No. Not on their own. You have to `}<em parentName="p">{`use`}</em>{` them.`}</p>
    <p>{`Technology is ever evolving and you have to stay sharp. Yes there's still demand for COBOL programmers, but you don't wanna be stuck in a stack.`}</p>
    <p>{`Use your understanding to jump ship. The more you understand, the easier new tech feels. `}<em parentName="p">{`"Oh Thingabob in NextJS is just Bobathing in Gatsby, d'oh"`}</em></p>
    <p>{`You can learn new things fast.`}</p>
    <p>{`That's what employers and clients pay you for my friend. Solving `}<em parentName="p">{`new`}</em>{` problems.`}</p>
    <p>{`You don't wanna be a factory worker churning widgets until the day you die, you want to design the factory.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`The important work is the work you haven’t done before. `}<br parentName="p"></br><br parentName="p"></br>{`We’re engineers not line cooks.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1283475726432264192"
      }}>{`July 15, 2020`}</a></blockquote>
    <p>{`You're solving new problems, building assets, saving and creating money. When `}<em parentName="p">{`you`}</em>{` build something, it's used for months and years.`}</p>
    <p>{`That's your job as an engineer. You create the flower for others' superpower.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: `}<a parentName="p" {...{
        "href": "https://learnetto.com/blackfriday"
      }}>{`the Standout Developer Bundle`}</a>{` is on sale until Monday`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      